export class ApplicationRoleTemplate {
    applicationId: number;
    applicationTemplateId: number;
    name: string;
    policies: Policy[];
    roles: Role[];
}

class Policy {
    id: number;
    name: string;
    policies: Policy[];
    roles: Role[];
}

class Role {
    id: number;
    name: string;
    permissionGroups: PermissionGroup[];
}

class PermissionGroup {
    id: number;
    displayName: string;
    permissions: Permission[];
}

class Permission {
    id: number;
    name: string;
}